import { subscriptionType } from './subscription.constants'

export const PLANS_NAME = {
  [subscriptionType.CLASSIC]: "Classic",
  [subscriptionType.CORPORATE]: "Corporate",
  [subscriptionType.FREE]: "Free",
  [subscriptionType.BASIC]: "Basic",
  [subscriptionType.BUSINESS]: "Business"
}
